import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../../core/modules/common/tools/noop';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';

const PostalItemSelector = (props) => {
  const {
    title = '',
    selected = [],
    onSelect = noop,
    itemNodes = [],
  } = props;

  return (
    <div className="operator-item-selector-container">
      {itemNodes.length ?
        <CheckboxTreeSelector
          title={title}
          nodes={itemNodes}
          selected={selected}
          expandDisabled
          onSelect={onSelect}
          allSelectorDisabled
        /> : <div />
      }
    </div>
  );
};

PostalItemSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  itemNodes: PropTypes.arrayOf(PropTypes.object),
};

export default PostalItemSelector;
